// store/actions/userActions.js

export const setJobInfo = (jobInfo) => {
 

  return {
    type: 'SET_JOB_INFO',
    payload: { jobInfo },
  };
};

export const updateJobInfo = (updatedInfo) => {
  return {
    type: 'UPDATE_JOB_INFO',
    payload: { updatedInfo },
  };
};

export const clearJobInfo = () => {
  return {
    type: 'CLEAR_JOB_INFO',
  };
};
